import { useEffect, useState } from 'react';

/**
 * Just to have information whenever initial list is already displayed
 * It's usefull for not showing appear animation for intial rows,
 * but only for new ones.
 */
export const useAppearAnimationIgnorePeriod = (items: unknown[]) => {
  const [delaying, setDelaying] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    if (!delaying) {
      if (items.length > 0 && dataLoaded === false) {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setDelaying(true);
        setTimeout(() => {
          setDataLoaded(true);
          setDelaying(false);
        }, 1000);
      }
      if (items.length === 0 && dataLoaded === true) {
        setDelaying(true);
        setTimeout(() => {
          setDataLoaded(false);
          setDelaying(false);
        }, 1000);
      }
    }
  }, [items, dataLoaded, delaying]);

  return !dataLoaded;
};
